<div class="row">
  <div class="col-md-12">

    <div class="box box-primary">

      <div class="box-body pt-1">

        <div class="row pt-2">

          <div class="col-md-3">
            <h5 class="txt-blue">Histórico do equipamento</h5>
          </div>
          <div class="col-md-2">
            <div class="btn-group d-flex">
              <button type="button" class="btn btn-light pl-2 pr-2 txt-gray" (click)="retreatYear()">
                <i class="fa fa-chevron-left"></i>
              </button>
              <button *ngFor="let ano of anos" type="button" class="btn" (click)="optionYear(ano)"
                [ngClass]="{'btn-info' : this.selectionYear == ano, 'btn-light' : this.selectionYear != ano }">{{ano}}
              </button>

              <button type="button" class="btn btn-light pl-2 pr-2 txt-gray" (click)="forwardYear()">
                <i class="fa fa-chevron-right"></i>
              </button>
              <!--               <button type="button" class="btn" (click)="optionYear(2021)"
                [ngClass]="{'btn-info' : this.selectionYear == 2021, 'btn-light' : this.selectionYear != 2021 }">2021
              </button>
 -->
            </div>

          </div>

          <div class="col-md-7">

            <div class="btn-group d-flex">
              <button *ngFor="let mes of meses" type="button" class="btn" (click)="optionMonth(mes.numero)"
                [ngClass]="{'btn-info' : this.selectionMonth == mes.numero, 'btn-light' : this.selectionMonth != mes.numero }">{{mes.nome_abrev}}
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>




<div class="row">
  <div class="col-md-12">

    <div class="box box-primary">

      <div class="box-body pt-0">


        <div class="row pt-2">

          <div class="col-md-3 text-center">
            <h5 style="font-size: 1.3em;" class="txt-blue">Identificador do Equipamento </h5>
            <h6 style="font-size: 1.1em; color: #808080">
              ID ou Nº Série
            </h6>
          </div>
          <div class="col-md-9 text-center">
            <h5 style="font-size: 1.3em;" class="txt-blue">
              OSs emitidas relacionadas ao equipamento
            </h5>
            <h6 style="font-size: 1.1em; color: #808080" *ngIf="this.equipamentoSelected != null">
              Código: <b>{{this.equipamentoSelected.nome}}</b> - Nº Série: <b>{{this.equipamentoSelected.numeroSerie}}</b>
            </h6>
          </div>
        </div>




        <div class="row pt-2">
          <div class="col-md-3" style="border-right: 1px solid #eee;">

            <div class="input-group input-group">
              <input type="text" class="form-control" #identificadorEquipamento id="identificador"
                placeholder="ex: 001" maxlength="5">
              <div class="input-group-append">
                <button class="btn btn-info"> <span class="pr-2 pl-2"
                    (click)="getEquipamentoByIdentificador(identificadorEquipamento.value)" title="buscar equipamento">OK
                  </span></button>
                <button class="btn btn-light" (click)="resetSearch()"> <i class="fa fa-times" title="Limpar busca"></i> </button>
                
              </div>
              <button class="btn btn-light ml-3"> <i class="fa fa-search" title="Pesquisa avançada"
                (click)="openModalPesquisa()"></i></button>
              
             

            </div>
           

            <div class="divider"></div>

            <section>
              <div class="form-group">
                <label for="">Código</label>
                <input class="form-control" type="text" [value]="this.equipamentoSelected?.nome" disabled>
              </div>

              <div class="form-group">
                <label for="">Descricao</label>
                <input class="form-control" type="text" [value]="this.equipamentoSelected?.descricao" disabled>
              </div>

              <div class="form-group">
                <label for="">Modelo</label>
                <input class="form-control" type="text" [value]="this.equipamentoSelected?.modelo" disabled>
              </div>

              <div class="form-group">
                <label for="">Ano fabricação</label>
                <input class="form-control" type="text" [value]="this.equipamentoSelected?.anoFabricacao" disabled>
              </div>

              <div class="form-group">
                <label for="">Tipo de Equipamento</label>
                <input class="form-control" type="text"
                  [value]="this.equipamentoSelected?.tipoDeEquipamento.descricao" disabled>
              </div>




            </section>

          </div>


          <div class="col-md-9 text-center">
            <!-- <app-ball-pulse *ngIf="isProcessingRanking"></app-ball-pulse> -->

            <section *ngIf="this.nenhumResultado == false; else nenhumEquipamentoSelecionado" >

              <app-grid-OSs [listaDeOSs]="this.resultadosPesquisa" [podeImprimir]="this.autorizacoes?.podeListar"
                [heightGridPx]=500>
              </app-grid-OSs>
            </section>

            <ng-template #nenhumEquipamentoSelecionado>

              <div>
                <span class="material-icons" style="font-size: 20em; color: #f0f0f0; margin-top: 20px;" >
                  grid_on
                </span><br />
                <span style="font-size: 1.2em; color: #808080">
                 <span *ngIf="this.equipamentoSelected"> Nenhuma OS encontrada para o equipamento selecionado</span>
                 <span *ngIf="!this.equipamentoSelected">Nenhum equipamento selecionado no momento</span>
                </span>
              </div>

            </ng-template>

            
          </div>
          
          
        </div>
        
        <div class="divider"></div>
        <!-- 3a linha -->
        <div class="row pt-2">

          <div class="col-md-3" style="border-right: solid 1px #eee;">

            
            <button type="button" class="btn btn-light btn-block btn-shadow"
              [disabled]="this.equipamentoSelected == undefined" 
              (click)="openModalDetalhesEquipamento()">
              <i class="fa fa-info-circle pr-3 fa-lg txt-blue"></i>
              Maiores detalhes do equipamento
            </button>
          </div>

          <div class="col-md-3">
           
            <button type="button" class="btn btn-light d-flex justify-content-start"
            (click)="exportarToExcel()"
            [disabled]="this.nenhumResultado == true || !this.autorizacoes?.podeListar"
            title="Gera uma planilha Excel com os dados apresentados na grid">
            <span class="material-icons pl-2 txt-green">table_view</span>
            <span class="pl-2 pr-2">Gerar planilha Excel</span>
            <span *ngIf="this.isGeneratingToExcel"
              class="fa fa-spinner fa-spin fa-fw pull-left txt-green"></span>
          </button>

          </div>

          <div class="col-md-3 text-center" [class.highlight]="excelFileName !== ''">
            <a *ngIf="excelFileName !== ''" [href]="hrefExcelFile" >{{excelFileName}}</a>  
          </div>

          <div class="col-md-3 text-right">

          </div>

        </div>


      </div>
    </div>
  </div>
</div>


<app-footer-basic></app-footer-basic>


<!--   ***************** MODAIS ******************** -->

<app-pesquisa-equipamento [shouldOpenModal]="this.shouldOpenModalPesquisa"
  (EnviarEquipamento)="displayEquipamento($event)">

</app-pesquisa-equipamento>



<app-detalhes-equipamento [shouldOpenModal]="shoulOpenModalDetalhesEquipamento"
  [equipamentoId]="this.equipamentoSelected?.id">

</app-detalhes-equipamento>